<template>
    <svg width="100px" height="100px" viewBox="0 0 100 100" class="inactiveSVG">
        <defs>
            <path
                id="inactive-path-1"
                d="M33.3333333,0 C51.742825,0 66.6666667,14.9238417 66.6666667,33.3333333 C66.6666667,51.742825 51.742825,66.6666667 33.3333333,66.6666667 C14.9238417,66.6666667 0,51.742825 0,33.3333333 C0,14.9238417 14.9238417,0 33.3333333,0 Z M33.3333333,6.5040648 C18.5159375,6.5040648 6.5040648,18.5159375 6.5040648,33.3333333 C6.5040648,48.1507292 18.5159375,60.1626019 33.3333333,60.1626019 C48.1507292,60.1626019 60.1626019,48.1507292 60.1626019,33.3333333 C60.1626019,26.2177689 57.3359549,19.3936395 52.304491,14.3621756 C47.2730272,9.33071176 40.4488978,6.5040648 33.3333333,6.5040648 Z M10.4166675,14.8360841 L14.8360848,10.4166667 L56.0839804,51.6645623 L51.664563,56.0839797 L10.4166675,14.8360841 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-/-Search-Icons-/-Regular-/-Inactive">
                <g id="Group" transform="translate(16.666667, 16.666667)">
                    <mask id="inactive-mask-2" fill="white">
                        <use xlink:href="#inactive-path-1"></use>
                    </mask>
                    <use
                        id="Combined-Shape"
                        fill="#000000"
                        fill-rule="nonzero"
                        xlink:href="#inactive-path-1"
                    ></use>
                    <g
                        id="Color-/-Grey-Color-/-Purple-/-Regular"
                        mask="url(#inactive-mask-2)"
                        fill="#5B74FF"
                    >
                        <g id="Color-/-Dark-Grey" transform="translate(-50.000000, -50.000000)">
                            <rect x="0" y="0" width="166.666672" height="166.666672"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'InactiveSVG',
};
</script>

<style lang="scss" scoped>
.inactiveSVG {
    position: absolute;
    top: 58px;
    left: 58px;
}
</style>
